import { useHistory } from "react-router"
import farmSo from "stores/farm"

export function getFarmId(farmId: string | number): number {
	if (Number.isInteger(+farmId)) {
		return +farmId
	}

	const name = farmId.toString().toLowerCase()
	const farm = farmSo.state.all?.find(f => f.farmCode.toLowerCase() == name || f.name.toLowerCase().includes(name))
	return farm?.id
}
export async function waitNavigate(url: string, history: ReturnType<typeof useHistory>) {

	if (!url) return {
		success: false,
		error: `Impossibile aprire "${url}"`
	}

	await new Promise<void>((resolve) => {
		const timer = setTimeout(() => { unlisten(); resolve() }, 3000)
		const unlisten = history.listen(() => {
			clearTimeout(timer)
			unlisten()
			resolve()
			// requestAnimationFrame(() => {
			// 	requestAnimationFrame(() => resolve()) // doppio: commit + paint
			// })
		})
		history.push(url)
	})

	return {
		success: true,
		navigatedTo: url,
	}

}


